import React, { useState, useEffect, memo, useCallback, useRef } from "react";
import {
  View,
  StyleSheet,
  ScrollView,
  ActivityIndicator,
  Modal,
} from "react-native";
import { useSelector } from "react-redux";
import Text from "@components/AppText";
import colors from "@constants/color";
import NoCoupons from "@assets/svg/NoCoupons";
import metrics from "@constants/metrics";
import analytics from "@services/analytics";
import refreshHOC from "@utils/refreshHOC";
import strings from "@constants";
import t from "@constants/localization";
import { getCouponsForUser } from "../../services/api";
import CouponToBeApplied from "./CouponToBeApplied";
import AvailableCoupon from "./AvailableCoupon";
import ManualApplyCoupon from "./ManualApplyCoupon";

const PATH = "screens/CouponScreen/index";

const { refresh: refreshScreenName } = strings;
const CouponScreen = (props) => {
  const [activeCoupon, setActiveCoupon] = useState(null);
  const [loading, setLoading] = useState(true);
  const [coupons, setCouponText] = useState([]);

  const {
    selectedContact: { user_id = "" },
  } = useSelector((state) => state.customer);

  const { cart_value, cart_items } = (props.route && props.route.params) || {};

  useEffect(() => {
    fetchCoupons();
  }, []);

  const fetchCoupons = () => {
    setLoading(true);
    getCouponsForUser(user_id)
      .then(({ data }) => {
        setCouponText(data.coupons);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  const handleActiveCoupon = (id) => {
    setActiveCoupon(id);
  };

  const handleToggleLoading = (value) => {
    setLoading(value);
  };

  return (
    <View style={{ flex: 1, backgroundColor: colors.primaryBg }}>
      <ScrollView
        contentContainerStyle={[
          coupons.length === 0 ? styles.listContainer : {},
        ]}
      >
        <View style={{ padding: metrics.baseGutter }}>
          <ManualApplyCoupon
            handleToggleLoading={handleToggleLoading}
            userId={user_id}
            cart_items={cart_items}
            cart_value={cart_value}
          />
        </View>

        {coupons.length > 0 && (
          <View
            style={{
              paddingHorizontal: metrics.baseGutter,
            }}
          >
            <View style={styles.seperatorStrip}>
              <Text
                style={{
                  color: colors.lightBlack,
                }}
              >
                {t(`${PATH}/availableCoupons`)}
              </Text>
            </View>

            {/* AvailableCoupon */}
            <View>
              {coupons &&
                coupons
                  .filter((c) => c.is_applicable)
                  .map((coupon) => (
                    <AvailableCoupon
                      cart_items={cart_items}
                      cart_value={cart_value}
                      handleActiveCoupon={handleActiveCoupon}
                      coupon={coupon}
                      key={coupon.id}
                      userId={user_id}
                      handleToggleLoading={handleToggleLoading}
                    />
                  ))}
              {coupons &&
                coupons
                  .filter((c) => !c.is_applicable)
                  .map((coupon) => (
                    <AvailableCoupon
                      cart_items={cart_items}
                      cart_value={cart_value}
                      handleActiveCoupon={handleActiveCoupon}
                      coupon={coupon}
                      key={coupon.id}
                      userId={user_id}
                      handleToggleLoading={handleToggleLoading}
                    />
                  ))}
            </View>
          </View>
        )}

        {coupons.length === 0 && !loading && (
          <>
            <View
              style={{
                flex: 1,
                justifyContent: "center",
              }}
            >
              <View style={{ alignItems: "center" }}>
                <NoCoupons />
                <View style={{ marginVertical: 10 }}>
                  <Text bold>{t(`${PATH}/couponNotAvailable`)}</Text>
                </View>
              </View>
            </View>
          </>
        )}
      </ScrollView>

      <CouponToBeApplied
        activeCoupon={
          activeCoupon
            ? coupons.find((coupon) => coupon.id === activeCoupon)
            : null
        }
        handleActiveCoupon={handleActiveCoupon}
        userId={user_id}
        handleToggleLoading={handleToggleLoading}
      />

      <Modal transparent visible={loading}>
        <View
          style={{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, .9)",
          }}
        >
          <ActivityIndicator size={60} color={colors.primary} />
        </View>
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  listContainer: {
    backgroundColor: colors.primaryBg,
    flex: 1,
  },
  beLikeRow: {
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
  },
  seperatorStrip: {
    paddingVertical: 4,
    marginVertical: 10,
  },
});

export default refreshHOC(refreshScreenName.coupons)(CouponScreen);
